function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-breadcrum-home",
  d: "M305.88,420.06,298.06,414l-8,6.06h1.88v5.64a2.54,2.54,0,0,0,2.54,2.54h7.17a2.54,2.54,0,0,0,2.54-2.54v-5.64Zm-3.69,5.64a.54.54,0,0,1-.54.54h-7.17a.54.54,0,0,1-.54-.54v-5.64h8.25Z",
  transform: "translate(-290.06 -414)"
});

var SvgBreadcrumbHome = function SvgBreadcrumbHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg_breadcrum_arrow_icon",
    "data-name": "Breadcrum Home Icon",
    viewBox: "0 0 15.81 14.24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBreadcrumbHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/breadcrumb_home.380760b6.svg";
export { ForwardRef as ReactComponent };